import { API_AUTH } from "./common";

const thuchiApi = {
  getList: () => API_AUTH.get("api/thuchi/quytienmat"),
};

export default thuchiApi;
